import { useEffect, useState } from 'react';

const useControlTotalInfo = ({ gridRef, queryData, amountField }) => {
  const [totalRows, setTotalRows] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [changeFlag, setChangeFlag] = useState(false);

  useEffect(() => {
    setChangeFlag(prev => !prev);
  }, [queryData]);

  useEffect(() => {
    const checkedRows = gridRef?.current?.api
      ?.getSelectedNodes()
      ?.filter(row => row?.displayed)
      ?.map(row => row?.data);
    const displayedRows = gridRef?.current?.api
      ?.getModel()
      ?.rowsToDisplay?.map(row => row?.data);

    if (checkedRows?.length > 0) {
      const checkedRowsLength = checkedRows?.length;
      setTotalRows(checkedRowsLength);

      if (amountField) {
        const checkedRowsAmount = checkedRows?.reduce(
          (acc, cur) => acc + Number(cur?.[amountField]),
          0,
        );
        setTotalAmount(checkedRowsAmount);
      }
    } else {
      const displayedRowsLength = displayedRows?.length || 0;
      setTotalRows(displayedRowsLength);

      if (amountField) {
        const displayedRowsAmount = displayedRows?.reduce(
          (acc, cur) => acc + Number(cur?.[amountField]),
          0,
        );
        setTotalAmount(displayedRowsAmount);
      }
    }
  }, [changeFlag]);

  return {
    totalRows,
    setTotalRows,
    totalAmount,
    setTotalAmount,
    changeFlag,
    setChangeFlag,
  };
};

export default useControlTotalInfo;
